import {Pipe, PipeTransform} from '@angular/core';
import {UtilService} from '../util/util.service';

@Pipe({
  name: 'checkNull'
})
export class CheckNullPipe implements PipeTransform {

  constructor(private util: UtilService) {
  }

  transform(value: any, args?: any): boolean {
    if (value instanceof Array) {
      return this.util.checkIfEmptyList(value);
    }
    return this.util.checkIfEmpty(value);
  }

}
